import React from 'react';
import SendMoneySuccessDF from '../components/SimulatorsComponents/DefualtSimulators/SendMoneySuccessDF';

//= ========================================================================
const Sim_J06_LoanSuccess = ({
  globJSON,
  selectedScreen,
  language,
  simPlatform,
  slideshowRefs = null,
}) => (
  <SendMoneySuccessDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    language={language}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
  />
);

export default Sim_J06_LoanSuccess;
